import * as React from 'react'
import RedirectPage from 'redirectPage'
import barcodesReportImage from 'images/barcodes-report.png'

const CHECKOUT_PERFORMANCE_TAB_NODE_ID = '-C18gFCPnl'

interface TrafficReportPageProps {
    accountSlug: string
}

const TrafficReportPage = ({ accountSlug }: TrafficReportPageProps) => (
    <RedirectPage
        oldPageTitle="Traffic Report"
        newPageTitle="Marketing Report"
        action="is now part of"
        image={barcodesReportImage}
        link={`/account/${accountSlug}/reports/marketing#${CHECKOUT_PERFORMANCE_TAB_NODE_ID}`}
    />
)

export default TrafficReportPage
